export function createBtnOptionAuthIter (buttonOptions = {}, menus = []) {
  return Object.keys(buttonOptions).reduce((obj, k) => {
    const { disabled, auth } = buttonOptions[k]
    obj[k] = [auth && !menus.includes(auth), disabled]
    return obj
  }, {})
}

const getKeys = obj => obj ? Object.keys(obj) : []

const authDisabled = (disabled, row) => {
  return (typeof disabled === 'function') ? disabled(row) : !!disabled
}

export function canavsCalculateAuthPlugin (vm) {
  let _buttonDisabledRowsMap = null
  let btnOptionAuthIter = {}

  const lifeCycleHooks = () => {
    vm.$on('hook:created', () => {
      setTimeout(() => {
        btnOptionAuthIter = createBtnOptionAuthIter(vm.buttonOptions, vm.$store.getters.permission.menus)
      })
    })
    vm.$watch('buttonOptions', () => {
      vm.getButtonOptions = getKeys(vm.buttonOptions)
      btnOptionAuthIter = createBtnOptionAuthIter(vm.buttonOptions, vm.$store.getters.permission.menus)
    })
  }
  const crateBtnDisabledRowsIter = () => {
    const data = vm.data || []
    if (!data.length) {
      return null
    }
    vm.buttonDisabledRowsIter = data.reduce((obj, cur, index) => {
      obj[index] = (item) => {
        return Object.keys(btnOptionAuthIter).reduce((obj, key) => {
          const [menuAuth, disabeld] = btnOptionAuthIter[key]
          obj[key] = menuAuth || authDisabled(disabeld, item)
          return obj
        }, {})
      }
      return obj
    }, {})
  }

  const setButtonDisabledRows = (item, index) => {
    if (vm.getButtonOptions.length > 0) {
      if (vm.buttonDisabledRowsIter) {
        if (!_buttonDisabledRowsMap) {
          _buttonDisabledRowsMap = {}
        }
        _buttonDisabledRowsMap[index] = vm.buttonDisabledRowsIter[index](item)
      } else {
        vm.setButtonDisable(item, index)
      }
    }
  }

  const usePluginButtonDisabledRows = () => {
    if (_buttonDisabledRowsMap) {
      vm.buttonDisabledRows = _buttonDisabledRowsMap
    }
  }

  lifeCycleHooks()
  return {
    crateBtnDisabledRowsIter,
    setButtonDisabledRows,
    usePluginButtonDisabledRows
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-canvas-table/helps/btn-auth.js